import React from "react"
import { Grid } from "react-bootstrap"
import CustomNavbar from "./CustomNavbar"
import MenuLeft from "./MenuLeft"
import "./styles.css"
import ToastNotifications from "../Notifications/ToastNotifications"

export default function App({ children }) {

  return (
    <div>

      <CustomNavbar />
      <ToastNotifications />

      <Grid fluid>
        <MenuLeft />
        <div className="main-content">
          { children }
        </div>
      </Grid>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/App/index.js